import Vue from 'vue';
import VueRouter from 'vue-router';

import UnsecuredLayout from '@/views/layouts/UnsecuredLayout.vue';
import SignOut from '@/views/SignOut.vue';
/* eslint-disable */
import signInRoutes from '@/router/routes/signIn';
import signUpRoutes from '@/router/routes/signUp';
import projectRoutes from '@/router/routes/projects';
import mainRoutes from '@/router/routes/main';
import { defaultGuard } from '@/router/guards';

import { views, DEFAULT_LOGGED_IN_ROUTE } from '@/router/constants';

Vue.use(VueRouter);

const routes = [
  // Modern sign-in on root route with UnsecuredLayout
  {
    path: '/',
    component: UnsecuredLayout,
    children: [
      {
        path: '',
        name: views.MODERN_SIGN_IN,
        component: () => import('@/views/ModernSignIn.vue'),
        meta: {
          allowedForUnauthorizedUsers: true,
        },
        beforeEnter: (to, from, next) => {
          // Import and use publicGuard
          import('@/router/guards').then(({ publicGuard }) => {
            publicGuard(to, from, next);
          });
        },
      },
    ],
  },
  {
    path: '/auth',
    component: UnsecuredLayout,
    children: [
      ...signUpRoutes,
      // Filter out the modern sign-in route from signInRoutes since it's now on root
      ...signInRoutes.filter(route => route.name !== views.MODERN_SIGN_IN),
      {
        path: '/sign-out',
        name: views.SIGN_OUT,
        component: SignOut,
      },
    ],
  },
  ...mainRoutes,
  ...projectRoutes,
  { path: '*', redirect: { name: DEFAULT_LOGGED_IN_ROUTE } },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(defaultGuard);

export default router;
